export default {
    apiKey: "AIzaSyDa8XauMXNPUaFbk_yoDOMJzfXvP_yyG_s",
    authDomain: "prep-chef.firebaseapp.com",
    projectId: "prep-chef",
    storageBucket: "prep-chef.appspot.com",
    messagingSenderId: "712848483744",
    appId: "1:712848483744:web:dc10812ce9d551c65c30c5",
    measurementId: "G-76XRWLHRTP"
};